<template>
  <div class="row q-col-gutter-md items-start">
    <div class="column col-12 items-end">
      <q-markup-table
        flat
        dense
      >
        <tbody>
          <tr>
            <td class="text-left">Descuento comercial</td>
            <td class="text-right">% {{ descuentoComercial }}</td>
          </tr>
          <tr>
            <td class="text-left">Descuento estratégico</td>
            <td class="text-right">% {{ descuentoEstrategico }}</td>
          </tr>
          <tr v-if="accesorios">
            <td class="text-left">Total Accesorios</td>
            <td class="text-right">{{ accesorios }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <div>Precio Unitario</div>
              <div>{{ precioUnitario }} <span v-if="cantidad > 1">x {{ cantidad }}</span></div>
            </td>
            <td class="text-right">
              {{ subtotal }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Total</td>
            <td class="text-right">{{ total }}</td>
          </tr>
        </tbody>
      </q-markup-table>
    </div>
  </div>
</template>

<script setup>
defineProps({
  total: String,
  cantidad: String,
  subtotal: String,
  precioUnitario: String,
  descuentoEstrategico: String,
  descuentoComercial: String,
  accesorios: String,
});
</script>

<style lang="scss" scoped></style>
